import React from 'react'
import {FinoptsysLogo, StateStreetFinancingHubLogoLong, StateStreetFinancingHubLogoShort} from '../styles/svg/svgIcons'

export const DynamicLogo = logo => {
	const flag = ['demo', 'qa', 'stg'].includes(process.env.REACT_APP_ENV)
	const finoptsysLogo = <div className='header-logo-color text-center f-24'>FinOptSys</div>

	const financingHubLogo = (
		<div className='header-logo-color text-center f-24'>
			<StateStreetFinancingHubLogoShort />
		</div>
	)

	const finoptsysLoginLogo = <FinoptsysLogo />

	const financingHubLoginLogo = (
		<div className='header-logo-color text-center mb-4'>
			<StateStreetFinancingHubLogoLong />
		</div>
	)

	if (logo === 'logo') return flag ? finoptsysLogo : financingHubLogo
	else if (logo === 'loginLogo') return flag ? finoptsysLoginLogo : financingHubLoginLogo
	else return null
}
